module.exports = __webpack_public_path__ + "img/profile.f5c2145f.svg";